var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container",class:{ link: _vm.link },on:{"click":function($event){_vm.link ? _vm.goToProfile() : null}}},[_c('v-avatar',{class:{shadow: _vm.shadow},attrs:{"color":_vm.color,"size":_vm.size,"src":_vm.avatar}},[(!_vm.avatar && !_vm.isAvatarLoading)?_c('div',{class:[
				'white--text font-weight-medium',
				{
					'font-7': _vm.xxs,
					'font-10': _vm.xs,
					'font-12': _vm.sm,
					'font-52': _vm.bg,
					'font-14': !_vm.xxs && !_vm.xs && !_vm.sm && !_vm.bg && !_vm.xxl,
				},
			]},[(_vm.firstLetter)?[_vm._v(" "+_vm._s(_vm.firstLetter)+" ")]:[_c('div',{staticClass:"px-2 py-2 white rounded-sm"},[_c('v-icon',[_vm._v("$empty-avatar")])],1)]],2):_vm._e(),(_vm.isAvatarLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),(!_vm.isAvatarLoading && _vm.avatar)?_c('v-img',{staticClass:"avatar-img",attrs:{"src":_vm.avatar.url}}):_vm._e()],1),(_vm.showActive)?_c('div',{staticClass:"avatar-user-active d-flex justify-center align-center"},[_c('div',{staticClass:"success"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }